// extracted by extract-css-chunks-webpack-plugin
module.exports = {"intro":"intro_00a8S"};